module.exports = __webpack_public_path__ + "img/Group 91.5b69e98e.png";